import { useCallback, useEffect, useRef, useState } from 'react';
const useActiveTabAnimation = (activeItem) => {
    const tabRefs = useRef(new Map());
    const [linePosition, setLinePosition] = useState({});
    const calculateActivePosition = useCallback(() => {
        requestAnimationFrame(() => {
            var _a, _b;
            const activeTab = tabRefs.current.get(activeItem);
            if (activeTab) {
                const tabWidth = activeTab.offsetWidth;
                const tabLabelWidth = (_b = (_a = activeTab.querySelector('span')) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : tabWidth;
                const tabPosition = activeTab.offsetLeft;
                const left = tabPosition + tabWidth / 2 - tabLabelWidth / 2;
                setLinePosition({
                    left: `${left}px`,
                    width: `${tabLabelWidth}px`,
                });
                activeTab.scrollIntoView({
                    block: 'nearest',
                    behavior: 'smooth',
                    inline: 'center',
                });
            }
        });
    }, [activeItem]);
    useEffect(() => {
        calculateActivePosition();
        window.addEventListener('resize', calculateActivePosition);
        return () => window.removeEventListener('resize', calculateActivePosition);
    }, [calculateActivePosition]);
    return {
        tabRef: (el) => {
            const key = el === null || el === void 0 ? void 0 : el.getAttribute('data-tab-key');
            if (key) {
                tabRefs.current.set(key, el);
            }
        },
        linePosition,
    };
};
export default useActiveTabAnimation;
//# sourceMappingURL=useActiveTabAnimation.js.map